<template>
  <div>
    <Headersys />
    <div class="content">
      <img class="gpy-img" :src="baseImg" alt="">
      <el-button type="primary" @click="getGPY">获取设备信息</el-button>
      <el-button type="success" @click="openGPY">打开摄像头</el-button>
      <el-button type="info" @click="takePhoto">拍照</el-button>
      <el-button type="danger" @click="jiupian">纠偏</el-button>
      <el-button type="warning" @click="coloseGPY">关闭摄像头</el-button>
      <!-- <div>
        <el-input v-model="X" placeholder="X"></el-input>
        <el-input v-model="Y" placeholder="Y"></el-input>
        <el-input v-model="W" placeholder="W"></el-input>
        <el-input v-model="H" placeholder="H"></el-input>
        <el-button type="primary" @click="detePhoto">图片裁剪</el-button>
      </div> -->
      <img class="gpy-img" v-for="(item, idx) in photoImg" :key="idx" :src="item.url" alt="">
      <el-button type="primary" @click="toPrintImg">打印</el-button>
      <el-button type="success" @click="shengchengPDF">生成PDF</el-button>
      <div style="height: 20vh;"></div>
    </div>
    <Back />
  </div>
</template>
<script>
import lodop from "@/assets/js/doPrint.js"
export default {
  name: '',
  data() {
    return {
      baseImg: "",//视频
      photoImg: [],//照片
      farmTime: null,//高拍仪获取帧定时器
      X: "",
      Y: "",
      W: "",
      H: ""
    };
  },
  created() {
  },
  mounted() {
  },
  // destroyed() {
  //   this.webSkt.close()
  // },
  methods: {
    shengchengPDF() {
      var imageList = []
      this.photoImg.forEach(el => {
        imageList.push(el.path)
      })
      this.$rqt.GPY_imageFile_pdfBase64({ imageList }).then(res => {
        console.log(res);
        lodop.pdfPrint(res.data)
      })
    },
    toPrintImg() {
      this.photoImg.forEach((el, idx) => {
        console.log('打印' + idx);
        this.localPrint(el.printImg)
      })
    },
    localPrint(base64String) {
      this.$rqt.localhost_print({
        base64String
      })
    },
    // 获取设备信息
    getGPY() {
      this.$rqt.GPY_GetAllDisplayInfo().then(res => {
        console.log(res);
      })
    },
    // 打开摄像头
    openGPY() {
      var data = {
        dev_idx: "0", // 摄像头 id
        res_id: "0" // 分辨率索引
      }
      this.$rqt.GPY_StartPreview(data).then(res => {
        if (res.returnCode == "0" || res.returnCode == "2") {
          this.farmTime = setInterval(() => {
            this.getFrame()
          }, 300);
        }
      })
    },
    // 获取针
    getFrame() {
      this.$rqt.GPY_getFrame().then(res => {
        if (res.returnCode == '0') {
          this.baseImg = "data:image/jpg;base64," + res.data.img
        }
      })
    },
    // 拍照
    takePhoto() {
      var data = {
        "filepath": "/tmp/gaopaiyi", // 本地文件保存位置
        "quality": "80", // 图片质量
        "color": "0" // 色彩模式(可选)；0:彩色(默认)，1:
      }
      this.$rqt.GPY_getPic(data).then(res => {
        console.log('拍照', res);
        if (res.returnCode == '0') {
          this.photoImg.push({
            printImg: res.data.img,
            url: "data:image/jpg;base64," + res.data.img,
            path: res.data.path
          })
        } else {
          this.$message.error(res.returnMsg)
        }
      })
    },
    // 纠偏
    jiupian() {
      var data = {
        "enable": "1"
      }
      this.$rqt.EnableDeskImage(data).then(res => {
        console.log('纠偏', res);
      })
    },
    // 图片裁剪
    detePhoto() {
      // var data = {
      //   x: this.X, // 起始点 x 坐标
      //   y: this.Y, // 起始点 y 坐标
      //   w: this.W, // 裁剪图片宽度
      //   h: this.H // 裁剪图片高度
      // }
      var data = {
        "x": "0", // 起始点 x 坐标
        "y": "0", // 起始点 y 坐标
        "w": "300", // 裁剪图片宽度
        "h": "300" // 裁剪图片高度
      }
      this.$rqt.detectCode(JSON.stringify(data)).then(res => {
        console.log('裁剪', res);
        if (res.returnCode == '0') {
          this.photoImg = "data:image/jpg;base64," + res.data
        } else {
          this.$message.error(res.returnMsg)
        }
      })
    },
    // 关闭高拍仪
    coloseGPY() {
      this.$rqt.GPY_StopPreview({
        dev_idx: "0"
      })
      clearInterval(this.farmTime)
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.idcard-title {
  min-height: 20vh;
  padding: 10px;
  border: 1px solid #ff0000;
  font-size: 6rem;
}

.sign-img {
  width: 100rem;
  height: 100rem;
  display: block;
}

.gpy-img {
  width: 120rem;
}
</style>